import axios from 'axios'
import store from '../store/index'

const clearAuthAndRedirect = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('role')
    store.commit('unauthenticateUser')

    if (window.location.pathname !== '/login' && window.location.pathname !== '/sso/callback') {
        window.location.href = '/login'
    }
}

const instance = axios.create({
    baseURL: process.env.VUE_APP_URL || "/api/",
    headers: {
        'Accept': 'application/json',
    },
    withCredentials: true,
});

instance.interceptors.request.use(
    config => {
        const token = store.getters.userToken || localStorage.getItem('token');

        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        } return config;
    },
    error => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            clearAuthAndRedirect()
        }

        return Promise.reject(error)
    }
);

export default instance;
